module.exports = __webpack_public_path__ + "static/pic03-b1f7a07c900973ed3104d4caf64ae961.webp";